import { Box, Dialog, Tooltip } from "@mui/material";
import { Close } from "@mui/icons-material";
import HideAppBar from "view/FrontEnd/HomePage/components/HideAppBar";
import Banner from "view/FrontEnd/HomePage/components/Banner";
import { SxProps } from "@mui/material";
import { IParallax, Parallax, ParallaxLayer } from '@react-spring/parallax'
import { Hidden } from '@mui/material';
import { useRef } from "react";





export default function BannerPreview({ open, handleClose, data, arrGallery }) {
  const parallax = useRef<IParallax>(null!)
  return (
    <Dialog
      fullScreen
      // sx={{ ".MuiDialog-paperScrollPaper": { overflowX: "hidden" } }}
      open={open}
      onClose={handleClose}
    >
      <Box
        className="main-container-banner"
        sx={{ maxWidth: "100vw", overflowX: "hidden", minHeight: "104vh"}}
      >
        <Box
          onClick={handleClose}
          sx={{
            cursor: "pointer",
            bgcolor: "#1976d2",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            width: "1.7em",
            height: "1.7em",
            borderRadius: "50%",
            position: "absolute",
            zIndex: 9999,
            top: "20px",
            right: "20px",
          }}
        >
          <Tooltip title={"ปิด"} >
            <Close sx={{ fontSize: "1em", alignSelf: "center" }} />
          </Tooltip>
        </Box>
        <Hidden smDown>
          <HideAppBar />
          <Banner bannerData={data} IsPreview/>
        </Hidden>

      </Box>
    </Dialog>
  );
}
